import type { FormSubmissionResponse } from '@qdf/shared';
import { FormLayout } from '../layout/FormLayout.js';
import { IntakeForm } from '../form/IntakeForm.js';

interface IntakePageProps {
  onSuccess: (response: FormSubmissionResponse) => void;
}

export function IntakePage({ onSuccess }: IntakePageProps) {
  return (
    <FormLayout
      title="Apply for Credit"
      subtitle="Complete the form below to apply for a line of credit with Quick Draw Funding. Fields marked with * are required."
    >
      <IntakeForm onSuccess={onSuccess} />
    </FormLayout>
  );
}
